export default __webpack_public_path__ + "static/media/office2-afterA-2048w.04d7f4a5.webp";